import { TopicSchema, type Topic } from "@engo/shared";
import { useTranslation } from "react-i18next";

const MAX_TOPICS = 3;

export function TopicPicker({ value, onChange }: { value: Topic[]; onChange: (next: Topic[]) => void }) {
  const { t } = useTranslation();

  function toggle(topic: Topic) {
    if (value.includes(topic)) {
      if (value.length === 1) return;
      onChange(value.filter((x) => x !== topic));
      return;
    }
    if (value.length >= MAX_TOPICS) return;
    onChange([...value, topic]);
  }

  return (
    <div>
      <div className="flex flex-wrap gap-1.5">
        {TopicSchema.options.map((topic) => {
          const selected = value.includes(topic);
          const disabled = !selected && value.length >= MAX_TOPICS;
          return (
            <button
              key={topic}
              type="button"
              onClick={() => toggle(topic)}
              disabled={disabled}
              className={`rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${
                selected
                  ? "border-[var(--primary)] bg-[var(--primary)]/15 text-[var(--accent)]"
                  : "border-[var(--glass-border)] text-[var(--text-muted)] hover:border-[var(--primary)]/50 hover:text-[var(--text-secondary)] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-[var(--glass-border)] disabled:hover:text-[var(--text-muted)]"
              }`}
            >
              {t(`topic.${topic}`)}
            </button>
          );
        })}
      </div>
      <p className="mt-1.5 text-xs text-[var(--text-muted)]">{t("topicPicker.hint", { max: MAX_TOPICS })}</p>
    </div>
  );
}
